<template>
    <!-- 팝업 -->

    <div class="pop_up_layer" v-show="state.isShow" :style="{ display: state.isShow ? 'block' : 'none' }" @click="fnEvent"></div>
    <div class="pop_up _terms" v-show="state.isShow" :style="{ display: state.isShow ? 'block' : 'none' }">
        <button class="close_btn icon_wrap" @click="fnEvent">
            <img src="img/close_btn2.png" alt="닫기" />
        </button>
        <div class="pop_tit">
            <p>{{ props.title }}</p>
        </div>

        <div class="content_wrap custom_scroll" v-html="props.content"></div>
        <!-- <div class="content_wrap custom_scroll" >
            <div class="terms_con">
                <p class="terms_tit">제 1 조 (목적)</p>
                <p class="terms_desc">
                    본 약관(이하 "약관")은 '서울특별시립 다시함께상담센터'(이하 "다시함께상담센터")와 회원에 관한 제반사항을 규정함을 목적으로 합니다.
                </p>
            </div>
            <div class="terms_con">
                <p class="terms_tit">제 2 조 (약관의 효력 등)</p>
                <p class="terms_desc">
                    1. 약관은 공시하고 상대방이 동의함으로써 효력을 발생합니다. 본 약관의 공시는 '서울특별시립 다시함께상담센터'
                    홈페이지(http://gamsi.dasi.or.kr/)에 게시하는 방법으로 합니다.
                    <br />
                    2. "다시함께상담센터"는 약관의 규제에 관한 법률 등 관련법을 위배하지 않는 범위 내에서 약관을 개정할 수 있습니다.
                </p>
            </div>
            <div class="terms_con">
                <p class="terms_tit">제 1 조 (목적)</p>
                <p class="terms_desc">
                    본 약관(이하 "약관")은 '서울특별시립 다시함께상담센터'(이하 "다시함께상담센터")와 회원에 관한 제반사항을 규정함을 목적으로 합니다.
                </p>
            </div>
            <div class="terms_con">
                <p class="terms_tit">제 2 조 (약관의 효력 등)</p>
                <p class="terms_desc">
                    1. 약관은 공시하고 상대방이 동의함으로써 효력을 발생합니다. 본 약관의 공시는 '서울특별시립 다시함께상담센터'
                    홈페이지(http://gamsi.dasi.or.kr/)에 게시하는 방법으로 합니다.
                    <br />
                    2. "다시함께상담센터"는 약관의 규제에 관한 법률 등 관련법을 위배하지 않는 범위 내에서 약관을 개정할 수 있습니다.
                </p>
            </div>
            <div class="terms_con">
                <p class="terms_tit">제 1 조 (목적)</p>
                <p class="terms_desc">
                    본 약관(이하 "약관")은 '서울특별시립 다시함께상담센터'(이하 "다시함께상담센터")와 회원에 관한 제반사항을 규정함을 목적으로 합니다.
                </p>
            </div>
            <div class="terms_con">
                <p class="terms_tit">제 2 조 (약관의 효력 등)</p>
                <p class="terms_desc">
                    1. 약관은 공시하고 상대방이 동의함으로써 효력을 발생합니다. 본 약관의 공시는 '서울특별시립 다시함께상담센터'
                    홈페이지(http://gamsi.dasi.or.kr/)에 게시하는 방법으로 합니다.
                    <br />
                    2. "다시함께상담센터"는 약관의 규제에 관한 법률 등 관련법을 위배하지 않는 범위 내에서 약관을 개정할 수 있습니다.
                </p>
            </div>
            <div class="terms_con">
                <p class="terms_tit">제 1 조 (목적)</p>
                <p class="terms_desc">
                    본 약관(이하 "약관")은 '서울특별시립 다시함께상담센터'(이하 "다시함께상담센터")와 회원에 관한 제반사항을 규정함을 목적으로 합니다.
                </p>
            </div>
            <div class="terms_con">
                <p class="terms_tit">제 2 조 (약관의 효력 등)</p>
                <p class="terms_desc">
                    1. 약관은 공시하고 상대방이 동의함으로써 효력을 발생합니다. 본 약관의 공시는 '서울특별시립 다시함께상담센터'
                    홈페이지(http://gamsi.dasi.or.kr/)에 게시하는 방법으로 합니다.
                    <br />
                    2. "다시함께상담센터"는 약관의 규제에 관한 법률 등 관련법을 위배하지 않는 범위 내에서 약관을 개정할 수 있습니다.
                </p>
            </div>
        </div> -->
    </div>
    <!-- 팝업 -->
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted } from "@/BaseComponent";

    export default {
        props: {
            isShow: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: "",
            },
            content: {
                type: String,
                default: "",
            },
        },
        emits: ["close"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                isShow: false as boolean,
            });

            onMounted(() => {
                state.isShow = props.isShow;

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const fnEvent = () => {
                emit("close");
            };
            return { state, fnEvent, props };
        },
    };
</script>
